import { defineMessages } from 'react-intl';

export const messages: {
	sessionExpiresPrefix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sessionExpired: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lessThanOneMinute: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minute: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hour: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	and: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	keepMeSignedInLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remindMeLaterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loginAgainLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sessionExpiresPrefix: {
		id: 'security.heartbeat.banner.session-expires-prefix',
		defaultMessage: 'Your session expires in',
		description: 'Prefix text for when session is expiring',
	},
	sessionExpired: {
		id: 'security.heartbeat.banner.session-expired',
		defaultMessage: 'Your session has expired',
		description: 'Text shown when session has expired',
	},
	lessThanOneMinute: {
		id: 'security.heartbeat.banner.less-than-one-minute',
		defaultMessage: 'less than 1 minute',
		description: 'Text for when less than one minute remains',
	},
	minute: {
		id: 'security.heartbeat.banner.minute',
		defaultMessage: 'minute',
		description: 'Singular form of minute',
	},
	minutes: {
		id: 'security.heartbeat.banner.minutes',
		defaultMessage: 'minutes',
		description: 'Plural form of minutes',
	},
	hour: {
		id: 'security.heartbeat.banner.hour',
		defaultMessage: 'hour',
		description: 'Singular form of hour',
	},
	hours: {
		id: 'security.heartbeat.banner.hours',
		defaultMessage: 'hours',
		description: 'Plural form of hours',
	},
	and: {
		id: 'security.heartbeat.banner.and',
		defaultMessage: 'and',
		description: 'Conjunction between hours and minutes',
	},
	keepMeSignedInLabel: {
		id: 'security.heartbeat.banner.keep-me-signed-in.label',
		defaultMessage: 'Keep me signed in',
		description: 'Text in the button to extend session',
	},
	remindMeLaterLabel: {
		id: 'security.heartbeat.banner.remind-me-later.label',
		defaultMessage: 'Remind me later',
		description: 'Text in the button to dismiss the session expiration banner',
	},
	warningIconLabel: {
		id: 'security.heartbeat.banner.warning-icon.label',
		defaultMessage: 'Warning',
		description: 'Accessibility label for warning icon',
	},
	loginAgainLink: {
		id: 'security.heartbeat.banner.login-again.link',
		defaultMessage: 'Log in again to continue',
		description: 'Link text to extend session',
	},
});
